import React from "react";
import OTP from "../../../../shared/forms/orb-otp";
import OrbButton from "../../../../shared/components/orb-button";
import { useTranslation } from "react-i18next";

const OneTimePassword = (props: any) => {
  const { save, selectedDetails, reSendOtp, otpLoading,resendOtpLoading } = props;
  const [otp, setOtp] = React.useState("");
  const { t } = useTranslation();


  const onSubmit = () => {
    save(otp, selectedDetails.id);
  };

  return (
    <>
      <div className={`d-flex align-items-end  justify-content-center pt-3 `}>
        <div>
          <OTP
            separator={<span> </span>}
            value={otp}
            onChange={setOtp}
            length={6}
          />
          <div className="mb-3 mt-2">
            <p className="d-flex justify-content-center header-font-bold mb-0  mohave ">
              {t("verification_code")}
            </p>
            <p className=" small-font mohave">{t('enter_verification_code')}</p>
          </div>
          <div>
            <div className={` mt-3 d-flex justify-content-between gap-2`}>
              <OrbButton
                type={"submit"}
                className={" mohave px-3 "}
                size={""}
                onBtnClick={reSendOtp}
                label={t('resend')}
                loading={resendOtpLoading}
              />

              <OrbButton
                type={"submit"}
                className={" mohave px-3 "}
                size={""}
                loading={otpLoading}
                onBtnClick={onSubmit}
                label={t('verify')}
                disabled={otp.length<6}
             
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OneTimePassword;
